import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { phoneNumberAutoFormat } from '@libs/helpers';
import { useEffect, useRef, useState } from 'react';
import Input from '../input/Input';
import Typography from '../typography/Typography';
import { PhoneIndexDiv, FlagImg, BorderBox, FlexBox, PhoneInputContainer, CustomErroMessage, } from './style';
const PhoneInput = ({ 
// label,
// sendCodeText,
// sendCodeId,
onSendCodeClick = () => ({}), value, testId, inputId, disabled, placeholder, errorMessage, sendCode, valid = true, labelTestId = 'input-label', errorTestId = 'input-error', onChangeText, onChange, ...restProps }) => {
    const [preValue, setPreValue] = useState(0);
    const animationFrameId = useRef(null);
    const removeAnimationFrame = () => {
        if (typeof animationFrameId.current === 'number') {
            window.cancelAnimationFrame(animationFrameId.current);
            animationFrameId.current = null;
        }
    };
    const handleChange = (e) => {
        if (disabled)
            return;
        const { value, name } = e.target;
        const valueToApply = phoneNumberAutoFormat(value);
        if (onChange) {
            const pointer = +(e.target.selectionStart || 0);
            const element = e.target;
            removeAnimationFrame();
            animationFrameId.current = window.requestAnimationFrame(() => {
                let pointerToApply = pointer;
                setPreValue(value.length);
                if (preValue > value.length && [4, 8].includes(pointer)) {
                    pointerToApply--;
                }
                else if ([4, 8].includes(pointer)) {
                    pointerToApply++;
                }
                element.selectionStart = pointerToApply;
                element.selectionEnd = pointerToApply;
            });
            const UpdatedEvent = {
                ...e,
                target: { ...e.target, value: valueToApply, name },
            };
            onChange(UpdatedEvent);
        }
        else if (onChangeText) {
            const { value } = e.target;
            onChangeText(value);
        }
    };
    useEffect(() => {
        return () => removeAnimationFrame();
    }, []);
    return (_jsxs(PhoneInputContainer, { "data-cy": testId, children: [_jsxs(FlexBox, { children: [_jsx(PhoneIndexDiv, { children: _jsxs(BorderBox, { children: [_jsx(FlagImg, {}), _jsx(Typography, { type: "subHeadline", children: "+995" })] }) }), _jsx(Input, { size: "lg", type: "text", inputMode: "numeric", value: value, valid: valid, maxLength: 11, inputId: inputId, disabled: disabled, onChange: handleChange, onClick: onSendCodeClick, sendCode: sendCode, placeholder: placeholder, labelTestId: labelTestId, testId: "changePhoneInput", ...restProps })] }), _jsx(CustomErroMessage, { errorMessage: errorMessage, errorTestId: errorTestId })] }));
};
export default PhoneInput;
//# sourceMappingURL=PhoneInput.js.map